import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const DesignHomeHead = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const { formatMessage } = useIntl();

  const fullText = formatMessage({ id: 'Home.design.subtitle' });

  useEffect(() => {
    let index = 0;
    const typingInterval = setInterval(() => {
      if (index < fullText.length) {
        setDisplayedText(fullText.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typingInterval);
      }
    }, 50); // Adjust the speed here (100 ms per character)

    return () => clearInterval(typingInterval); // Cleanup function
  }, [fullText]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500); // Toggle cursor visibility every 500ms

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <>
    <div className='concontainer'>

      <div className="header-container">
        <div className="main-text">
          <FormattedMessage id="Home.design.title" />
          <div className="title-separator">
            <FormattedMessage id="Home.design.title2" />
          </div>
        </div>
        <div className="home-head">
          {displayedText}
          <span className={`cursor ${showCursor ? 'visible' : 'hidden'}`}>|</span>
        </div>
      </div>
      </div>

      <style jsx>{`
        .concontainer{
          width: 100vw;
          display: flex;
          justify-content: center;
          align-items: center;
        
        }
        .header-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          max-width: 750px;
          margin-top: 100px; /* Add margin */  
        }
        .main-text {
          font-size: 72px; /* Large text size */
          font-weight: bold;
          color: #123E7B; /* Text color */
          background: linear-gradient(to right,  #3B7BEB 30%, #FFBD4C); /* Gradient colors */
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent; /* Text color becomes transparent to show gradient */
          line-height: 1; /* Remove extra line height */
        }
        .title-separator {
          display: inline-block;
          font-size: 72px; /* Matching size */
          font-weight: bold;
          background: linear-gradient(to right, #FFBD4C 30%,  #3B7BEB ); /* Gradient colors */
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent; /* Text color becomes transparent to show gradient */
          margin: 0; /* Remove margin */
          line-height: 1.1; /* Remove extra line height */
        }
        .home-head {
          font-size: 22px;
          font-weight: bold;
          color: #123E7B; /* Text color */
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px; /* Add margin */
        }
        .cursor {
          font-weight: bold;
          font-size: 32px;
          color: #FFBD4C; /* Cursor color */
          transition: opacity 0.2s;
        }
        .visible {
          opacity: 1;
        }
        .hidden {
          opacity: 0;
        }
      `}</style>
    </>
  );
};

export default DesignHomeHead;
